import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import Home from "@/pages/Home";
import HowWeWork from "@/pages/HowWeWork";
import Work from "@/pages/Work";
import CaseStudy from "@/pages/CaseStudy";
import Contact from "@/pages/Contact";
import SteelCaseStudy from "@/pages/SteelCaseStudy";
import "@/App.css";

function App() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
    });

    let frameId;
    function raf(time) {
      lenis.raf(time);
      frameId = requestAnimationFrame(raf);
    }
    frameId = requestAnimationFrame(raf);

    return () => {
      cancelAnimationFrame(frameId);
      lenis.destroy();
    };
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/how-we-work" element={<HowWeWork />} />
        <Route path="/work" element={<Work />} />
        <Route path="/work/diagnostics-voice-agent" element={<CaseStudy />} />
        <Route path="/work/whatsapp-order-capture" element={<SteelCaseStudy />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
